import React, {useContext, useEffect, useState} from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
import OrderList from "./OrderList";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import {AppContext} from "../../contexts/AppContext";
import Modes from "../../contexts/Modes";
import RouteNames from "../../contexts/RouteNames";

const DONE_STATUS = ["READY_TO_DISPATCH"];

const OrderReady = () => {
  const {height, width} = useWindowDimensions();
  const {
    orders,
    isInitialOrderLoading,
    setMode,
    setCurrentRouteName,
    loggedIn,
    setLoggedIn
  } = useContext(AppContext);

  const characterWidth = 23;
  const minItemWidth = 230;
  const maxItemWidth = 440;
  const itemHeight = 60;
  const topOffset = 75;
  const horizontalOffset = 10;

  const [preparingItems, setPreparingItems] = useState([]);
  const [doneItems, setDoneItems] = useState([]);
  const [itemsPerLine, setItemsPerLine] = useState(28);
  const [preparingItemsColumnCount, setPreparingItemsColumnCount] = useState(0);
  const [doneItemsColumnCount, setDoneItemsColumnCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [itemWidth, setItemWidth] = useState(minItemWidth);

  const getReadyToDispatchTime = (statusHistory) => {
    const readyToDispatchedTIme =
        statusHistory.find(
            s => s.status === "READY_TO_DISPATCH")?.eventCompletedTime ??
        statusHistory.find(s => s.status === "PREPARED")?.eventCompletedTime ??
        Date.now();
    return Number(readyToDispatchedTIme);
  }

  useEffect(() => {
    setMode(Modes.ORDER_READY);
    setCurrentRouteName(RouteNames.ORDER_READY);

    if (!loggedIn) {
      setLoggedIn(true);
    }

  }, []);

  useEffect(() => {
    let timer
    if (!isInitialOrderLoading) {
      timer = setTimeout(() => {
        //need time to load after initial calculations, This exclude network latency
        setIsLoading(false);
      }, 5000);
    } else {
      setIsLoading(true);
    }
    return () => clearTimeout(timer);
  }, [isInitialOrderLoading]);

  useEffect(() => {
    const tempPreparingItems = [];
    const tempDoneItems = [];
    let maxWidth = minItemWidth;
    orders?.forEach(o => {
      const tempItemWidth = o.externalId.length * characterWidth;
      if (maxWidth < tempItemWidth) {
        maxWidth = tempItemWidth > maxItemWidth?  maxItemWidth : tempItemWidth;
      }
      if (DONE_STATUS.includes(o.status)) {
        tempDoneItems.push({
          id: o.externalId,
          updatedTime: getReadyToDispatchTime(o.statusHistory ?? [])
        });
      } else {
        tempPreparingItems.push(o.externalId);
      }
    })
    setPreparingItems(tempPreparingItems);
    setDoneItems(
        tempDoneItems.sort((a, b) => a.updatedTime - b.updatedTime).map(
            item => item.id));
    setItemWidth(maxWidth);
  }, [orders]);

  useEffect(() => {
    const maxColumnCount = Math.floor((width - horizontalOffset) / itemWidth);
    setPreparingItemsColumnCount(Math.floor(maxColumnCount / 2));
    setDoneItemsColumnCount(Math.floor((maxColumnCount + 1) / 2));
    setItemsPerLine(Math.floor((height - topOffset) / itemHeight));
  }, [height, width, itemWidth]);

  return (<div style={{
    backgroundColor: "#FFFFFF",
    width: "100%",
    height: "100%",
    padding: "10px 20px",
    display: "flex",
    flexDirection: width < 520 ? "column" : "row",
    columnGap: "15px",
    rowGap: "15px",
    overflow: "scroll"
  }}>
    {!isLoading ? <OrderList
        title="Preparing"
        columnsCount={preparingItemsColumnCount}
        itemsPerLine={itemsPerLine}
        titleBackgroundColor="#243FFA"
        itemWidth={itemWidth}
        itemHeight={itemHeight}
        items={preparingItems}/> : null}
    {!isLoading ? <OrderList title="Done"
                             columnsCount={doneItemsColumnCount}
                             titleBackgroundColor="#6EB648"
                             itemsPerLine={itemsPerLine}
                             itemWidth={itemWidth}
                             itemHeight={itemHeight}
                             items={doneItems}/>
        : null}
    {isLoading ? <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%'
    }}><CircularProgress/></div> : null}
  </div>)
}

export default OrderReady;
